module.exports = __webpack_public_path__ + "static/media/Burma.3b4d0f27.png";